export default [
  { link: "https://vk.com/transgrant", title: "Транспортный грант" },
  { link: "https://vk.com/liga_forum", title: "Лига форум" },
  { link: "https://vk.com/studentgodart", title: "Студент года" },
  { link: "https://vk.com/dostizheniye_goda", title: "Достижение года" },
  { link: "https://vk.com/mol_ipoteka", title: "Молодёжный жилищный конкурс" },
];
